import './tailwind.css';
import { createApp } from 'vue';
import App from './App.vue';

Office.onReady(() => {
  let isWebView2Supported = true; // Assume it's supported

  try {
    // Attempt to use a feature only available in modern browsers
    new URL("https://example.com"); // URL API is widely supported in modern browsers
  } catch (e) {
    isWebView2Supported = false;
  }
  if (!isWebView2Supported) {
    document.getElementById("compatibility-message").style.display = "block";
  }

  // mount the app anyway.
  createApp(App).mount('#app');
});
